module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.odnoklassniki-13ee97f0dd7c8162c3dfca06c0e9f96b.png";